import React from 'react'
import Modal from '../../../components/Modal'

export default function PaidPeriodModal({
  paidPeriodModal,
  setPaidPeriodModal,
  paidPeriodSaving,
  handlePaidPeriodPayNow,
  handlePaidPeriodTransfer,
  formatMoney
}) {
  return (
    <Modal
      isOpen={!!paidPeriodModal}
      onClose={() => !paidPeriodSaving && setPaidPeriodModal(null)}
      title="Период уже оплачен"
      isBottomSheet={true}
    >
      {paidPeriodModal && (
        <div style={{ padding: '8px 0' }}>
          <div style={{
            background: 'var(--warning-bg, rgba(245,158,11,0.1))',
            border: '1px solid var(--warning, #F59E0B)',
            borderRadius: 'var(--radius-md, 12px)',
            padding: '16px',
            marginBottom: '20px',
            fontSize: '14px',
            lineHeight: '1.6'
          }}>
            <div style={{ fontWeight: 600, marginBottom: '8px', color: 'var(--warning, #F59E0B)' }}>
              {paidPeriodModal.type === 'bonus' ? 'Премия' : 'Штраф'} {formatMoney(paidPeriodModal.amount)}
            </div>
            <div style={{ color: 'var(--text-secondary)' }}>
              Сотрудник: <strong style={{ color: 'var(--text-primary)' }}>{paidPeriodModal.employeeName}</strong>
            </div>
            <div style={{ color: 'var(--text-secondary)', marginTop: '4px' }}>
              Период <strong style={{ color: 'var(--text-primary)' }}>{paidPeriodModal.periodLabel}</strong> уже полностью выплачен ({formatMoney(paidPeriodModal.paid)} из {formatMoney(paidPeriodModal.earned)}).
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {paidPeriodModal.type === 'bonus' && (
              <button
                className="btn"
                disabled={paidPeriodSaving}
                onClick={handlePaidPeriodPayNow}
                style={{
                  background: 'var(--aurora-gradient, linear-gradient(135deg, #14B8A6, #3B82F6))',
                  color: '#fff',
                  border: 'none',
                  padding: '14px 20px',
                  borderRadius: 'var(--radius-md, 12px)',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  justifyContent: 'center',
                  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                  boxShadow: '0 2px 8px rgba(59,130,246,0.25)',
                }}
              >
                {paidPeriodSaving ? 'Сохранение...' : `Доплатить ${formatMoney(paidPeriodModal.amount)} сейчас`}
              </button>
            )}

            <button
              className="btn"
              disabled={paidPeriodSaving}
              onClick={handlePaidPeriodTransfer}
              style={{
                background: 'var(--surface-hover, rgba(59,130,246,0.1))',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-color, rgba(59,130,246,0.2))',
                padding: '14px 20px',
                borderRadius: 'var(--radius-md, 12px)',
                fontSize: '15px',
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                justifyContent: 'center',
                transition: 'transform 0.15s ease',
              }}
            >
              {paidPeriodSaving ? 'Сохранение...' : `Перенести в следующий период`}
            </button>
            
            <div style={{ 
              fontSize: '12px', 
              color: 'var(--text-muted, #64748B)', 
              textAlign: 'center',
              lineHeight: '1.5',
              marginTop: '4px'
            }}>
              {paidPeriodModal.type === 'bonus' 
                ? '«Доплатить» — сохранит премию и создаст выплату. «Перенести» — премия войдёт в следующую выплату.'
                : '«Перенести» — штраф будет вычтен из следующей выплаты.'}
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}
